import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { RiskMinor } from '@shopify/polaris-icons';
import { Icon } from '@shopify/polaris';
import { FlexboxContainer } from '../common';

const ReadOnlySection = styled(FlexboxContainer)`
  justify-content: flex-start;
  align-items: center;
`;

const YieldContainer = styled.div`
  height: 22px;
  width: 20px;
  margin: 0 5px 0 0;
`;

const Text = styled.div<{ useDefaultTextColor?: boolean }>`
  font-weight: 400;
  line-height: 2rem;
  color: ${(props) => (props.useDefaultTextColor ? undefined : '#6d7175')};
`;

interface ReadOnlyTextProps {
  text: React.ReactNode;
  useDefaultTextColor?: boolean;
}

const ReadOnlyText: FunctionComponent<ReadOnlyTextProps> = (props) => {
  const { text, useDefaultTextColor } = props;

  return (
    <>
      <ReadOnlySection>
        <YieldContainer>
          <Icon source={RiskMinor} color="warning" />
        </YieldContainer>
        <Text useDefaultTextColor={useDefaultTextColor}>{text}</Text>
      </ReadOnlySection>
    </>
  );
};

export default ReadOnlyText;
